:host {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-sizing: border-box;
}

.sportsline-promoted-expert-picks--loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
